import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { getQuestionResponseVideos } from '../../requests/api/question-response';
import { generateVideoUrl } from '../../utils/videoUrl';

const PublicVideoView = () => {
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentVideo, setCurrentVideo] = useState(null);
  const { taskResponseId, questionResponseId } = useParams();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await getQuestionResponseVideos({ taskResponseId, questionResponseId });

        if (response.data.data && response.data.data[0]?.QuestionResponseVideos?.length > 0) {
          const videoList = response.data.data[0].QuestionResponseVideos.map((video) => ({
            id: video.id,
            url: generateVideoUrl(video.videoKey) || video.videoUrlEdit || video.videoUrl,
            title: `Video ${video.id}`,
            transcription: video.transcription,
            path: video.videoKey,
          }));

          setVideos(videoList);
          setCurrentVideo(videoList[0]);
        }
      } catch (_) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    if (taskResponseId && questionResponseId) {
      fetchVideos();
    }
  }, [taskResponseId, questionResponseId]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={3} position="relative">
      {/* Logo TCG en la esquina superior derecha */}
      <Box
        position="absolute"
        top={16}
        right={16}
        zIndex={1000}
      >
        <img
          src={isLight ? '/logo-lockup-light.png' : '/logo-lockup-dark.png'}
          alt="TCG Scout"
          style={{ height: '32px', width: 'auto' }}
        />
      </Box>

      <Typography variant="h4" gutterBottom>
        Videos de respuesta/detalle: {taskResponseId}/{questionResponseId}
      </Typography>

      {currentVideo && (
        <Box mb={3}>
          <video
            controls
            width="100%"
            height="400px"
            src={currentVideo.url}
          >
            Tu navegador no soporta el elemento video.
          </video>

          {currentVideo.transcription && (
            <Box mt={2}>
              <Typography variant="h6">Transcripción:</Typography>
              <Typography variant="body1">
                {currentVideo.transcription}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {videos.length > 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Otros Videos:
          </Typography>
          <Box display="flex" gap={2}>
            {videos.map((video) => (
              <Box
                key={video.id}
                onClick={() => setCurrentVideo(video)}
                style={{ cursor: 'pointer', border: currentVideo?.id === video.id ? '2px solid blue' : '1px solid gray' }}
                p={1}
              >
                <Typography variant="body2">{video.title}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PublicVideoView;
